import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddNewServiceValidation from "../../../../yup/Service/AddService";
import CommanForm from "../../../../components/FormController/Commanform";
import { CategoryAction } from "../../../../redux/Action/ProfileAction";
import Sidebar from "../../../../components/Layout/Sidebar";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import Addcategory from "../../../../components/Model/Addcategory";
import CategoryItem from "./CategoryItem";
import Errormessages from "../../../../components/ErrorMessage/Errormessages";
import Select from 'react-select';
import { durationOptions } from "../../../../constants/Constants";
import { decodeID, getLastURL, handleInput, sidebarOpen } from "../../../../utils/Helper";
import StaffMemberItem from "./StaffMemberItem";
import { AddServiceAction, ServiceManagementDetailAction, ServiceManagementUpdateAction } from "../../../../redux/Action/DashboardAction";
import Button from "../../../../components/Ui/Button";
import { useLocation, useNavigate } from "react-router-dom";
import UpdateServiceManagementvalidation from "../../../../yup/Service/EditService";
import Spinner from "../../../../components/Spinner";

import { FormattedMessage } from "react-intl";
import { useIntl } from 'react-intl';

const ServiceManagementUpdate = () => {
    const intl = useIntl();
    const local_language = localStorage.getItem('lang')


    const dispatch = useDispatch<any>();
    const service_update = useSelector((state: any) => state.ServiceManagementUpdateState)
    const serviceManagementDetail: any = useSelector((state: any) => state.ServiceManagementDetailState)
    const staff_member_detail: any = useSelector((state: any) => state.StaffMemberListState)
    const get_category_detail: any = useSelector((state: any) => state.CategoryState)
    const [staffMember, setStaffMember] = useState([]);
    const [staffData, setStaffData] = useState([])

    const navigate = useNavigate()
    const [staffError, setStaffError] = useState("")
    const location = useLocation();
    const viewId = getLastURL(location);

    const params = { detail_id: decodeID(viewId) };

    const { register, errors, handleSubmit, setValue, trigger, watch, getValues } = CommanForm({
        validationSchema: UpdateServiceManagementvalidation, defaultValues: {
            name: "", price: "", description: "", duration: "", category: "", staff_member: ""
        }
    });



    const handleAddCategoryClick = () => {
        dispatch(CategoryAction({ exclude: true }))
    }




    /* *************************** handle on submit *************************** */
    const onSubmit = (payload: any) => {
        if (staffData?.length == 0) {
            return setStaffError(local_language == "alb" ? "Ju lutemi zgjidhni të paktën një anëtar të stafit" : "Please select at least one staff member")
            // return setStaffError("Please select at least one staff member")
        } else {
            setStaffError("")
        }
        const uniqueStaffData = staffData.filter((value: any, index: any, self: any) => self.indexOf(value) === index);


        const data = {
            service: {
                name: payload?.name,
                price: payload?.price,
                description: payload?.description,
                duration: payload?.duration,
                cat_id: Number(payload?.category), staff_ids: uniqueStaffData,
            }, edit_id: params?.detail_id
        }
        dispatch(ServiceManagementUpdateAction(data))
    };


    const handleSelectedCategory = (id: any) => {
        setValue("category", id);
        // setcategories(id)
        trigger("categor")
    }

    const handleSelectedStaffMember = (id: any) => {
        setStaffData(id);
    };

    const handleError = () => {
        if (staffData?.length == 0) {
            return setStaffError(local_language == "alb" ? "Ju lutemi zgjidhni të paktën një anëtar të stafit" : "Please select at least one staff member")
        } else {
            return setStaffError("")
        }

    }

    useEffect(() => {
        setStaffError("")
    }, [staffData]);


    const breadcrumbItemsEdit = [
        { title: 'dashboard', link: '/dashboard' },
        { title: 'service_management', link: '/service-management' },
        { title: 'edit_service' }
    ];

    useEffect(() => {
        dispatch(ServiceManagementDetailAction(params))
    }, [])

    // const [durationData,setDuration]
    useEffect(() => {
        if (serviceManagementDetail?.status) {
            setValue("name", serviceManagementDetail?.data?.data?.name);
            setValue("price", serviceManagementDetail?.data?.data?.price);
            setValue("description", serviceManagementDetail?.data?.data?.description);
            setValue("duration", serviceManagementDetail?.data?.data?.duration);
            setValue("category", serviceManagementDetail?.data?.data?.cat_id);
            setValue("staff_member", serviceManagementDetail?.data?.data?.selected_services);
            setStaffMember(serviceManagementDetail?.data?.data?.selected_services)
        }
    }, [serviceManagementDetail]);


    useEffect(() => {
        if (service_update?.status) {
            navigate("/service-management")
        }
    }, [service_update]);


    useEffect(() => {
        return () => {
            dispatch(ServiceManagementDetailAction("RESET"))
            dispatch(ServiceManagementUpdateAction("RESET"))
        }
    }, []) // Reset data

    const handleSelectChange = (selectedOption: any) => {
        setValue(`duration`, selectedOption ? selectedOption.value : '');
        trigger(`duration`)
    };

    return (
        <>
            <div className='col-lg-9 addNewService'>
                {serviceManagementDetail?.loading || staff_member_detail?.loading || get_category_detail?.loading ? <Spinner /> : ""}
                <div className='dashboard bg-white'>
                    <div className='dashboardTop'>
                        <h2><button type='button' className='btn mobileMenu p-1 d-lg-none' onClick={() => { sidebarOpen() }} ><span className="icon-menu-right"></span></button>  {<FormattedMessage id="edit_new_service" />}</h2>
                        <Breadcrumb items={breadcrumbItemsEdit} />
                    </div>
                    <div className='dashboarcard'>
                        <div className='row'>
                            <div className='col-xl-10'>
                                <form onSubmit={handleSubmit(onSubmit)} >
                                    <div className='profileINfo'>
                                        <ul className='addCategory'>
                                            {
                                                <li className='addCatBTN cursor-pointer' data-bs-toggle="modal"
                                                    data-bs-target="#AddCategory"
                                                    onClick={handleAddCategoryClick} >
                                                    <figure><i className="icon-plus-line"></i></figure>
                                                    <p><FormattedMessage id="add_category" /></p>
                                                </li>
                                            }
                                            <CategoryItem handleSelectedCategory={handleSelectedCategory} watch={watch} />
                                        </ul>
                                        <Errormessages errors={errors} name="category" />

                                        <div className='serviceRow mb-4'>
                                            <div className='row gx-2 gy-4'>
                                                <div className='col'>
                                                    <div className='row gy-4'>
                                                        <div className="col-md-4 normalINput">
                                                            <label className="form-label">{<FormattedMessage id="service_name" />}</label>
                                                            <input type="text" className="form-control"
                                                                placeholder={intl.formatMessage({ id: 'enter_service_name' })}

                                                                {...register("name")}
                                                                onInput={(e: any) => {
                                                                    const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                                    setValue("name", value);
                                                                }}

                                                            />
                                                            <Errormessages errors={errors} name="name" />
                                                        </div>

                                                        <div className="col-md-4 normalINput normalINputIcon">
                                                            <label className="form-label"><FormattedMessage id="service_price" /></label>
                                                            <div className="position-relative">
                                                                <input type="text" className="form-control" placeholder="00.00/person"
                                                                    {...register(`price`)} onInput={handleInput} />
                                                                <span className='priceSIgn'>€</span>
                                                            </div>
                                                            <Errormessages errors={errors} name={`price`} />
                                                        </div>

                                                        <div className="col-md-4 normalINput">
                                                            <label className="form-label"><FormattedMessage id="service_duration" /></label>
                                                            <Select
                                                                value={durationOptions.find(option => option?.value == watch('duration'))}

                                                                {...register(`duration`, { required: true })}
                                                                options={durationOptions}
                                                                placeholder={intl.formatMessage({ id: 'service_duration' })}
                                                                onChange={(e: any) => handleSelectChange(e)}
                                                            />
                                                            <Errormessages errors={errors} name={`duration`} />
                                                        </div>

                                                        <div className="col-md-12 normalINput">
                                                            <label className="form-label"><FormattedMessage id="service_description" /></label>
                                                            <textarea className="form-control" rows={3} placeholder={intl.formatMessage({ id: 'write_description' })}
                                                                {...register(`description`)}
                                                                onInput={(e: any) => {
                                                                    const value = e.target.value.replace(/\s{2,}/g, ' ');
                                                                    setValue("description", value);
                                                                }}


                                                            ></textarea>
                                                            <Errormessages errors={errors} name={`description`} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='category staffRow mt-3'>
                                                <h6><FormattedMessage id="staff_member" /> </h6>
                                                <ul>
                                                    <StaffMemberItem handleSelectedStaffMember={handleSelectedStaffMember} staffData={staffMember}
                                                        watch={watch}
                                                    />
                                                </ul>
                                                {staffError && <p className="text-danger"> {staffError}</p>}
                                            </div>
                                        </div>

                                    </div>
                                    <Button text={<FormattedMessage id="Save" /> as any} type="Submit" className="btn btn-fill" onClick={handleError} isLoading={service_update?.loading} />
                                    {/* <button type="submit" className="btn btn-fill" onClick={handleError}>Save</button> */}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Addcategory />
        </>
    )
}

export default ServiceManagementUpdate;

